import React from 'react';
import { Handshake, Award, TrendingUp } from 'lucide-react';
import { customerLogos } from '../mock';

export const Customers = () => {
  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...customerLogos, ...customerLogos, ...customerLogos];

  return (
    <section id="customers" className="py-16 md:py-24 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            Our Customers
          </h2>
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            We are proud to serve leading industries worldwide, delivering high-quality vulcanizing machines 
            that power critical operations in mining, cement, steel, and material handling sectors.
          </p>
        </div>

        {/* Logo Carousel */}
        <div className="mb-16 overflow-hidden">
          <div className="logo-carousel-track">
            {duplicatedLogos.map((customer, index) => (
              <div 
                key={`${customer.id}-${index}`}
                className="logo-carousel-item"
              >
                <img 
                  src={customer.logo} 
                  alt={customer.name}
                  className="w-full h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <Handshake size={48} className="text-blue-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Trust & Partnership</h3>
            <p className="text-gray-400">Building long-term relationships with our clients</p>
          </div>
          <div className="text-center">
            <Award size={48} className="text-blue-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Quality Assurance</h3>
            <p className="text-gray-400">Delivering excellence in every machine we build</p>
          </div>
          <div className="text-center">
            <TrendingUp size={48} className="text-blue-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">Repeat Business</h3>
            <p className="text-gray-400">Our satisfied customers keep coming back</p>
          </div>
        </div>
      </div>
    </section>
  );
};